export const PATH_IDENTIFICATION = "/identification";
export const KEY_IDENTIFICATION = "identification";
export const TITLE_IDENTIFICATION = "Identification";

export const PATH_IDENTIFICATION_DASHBOARD = `${PATH_IDENTIFICATION}/dashboard`;
export const KEY_IDENTIFICATION_DASHBOARD = `${KEY_IDENTIFICATION}/dashboard`;
export const TITLE_IDENTIFICATION_DASHBOARD = "Tableau de bord des identifications ";

export const PATH_CAMPAGNE_IDENTIFICATION = `${PATH_IDENTIFICATION}/campagne`;
export const KEY_CAMPAGNE_IDENTIFICATION = `${KEY_IDENTIFICATION}/campagne`;
export const TITLE_CAMPAGNE_IDENTIFICATION = "Liste des campagnes d'identification";

export const PATH_IDENTIFICATION_ANIMAL = `${PATH_IDENTIFICATION}/animaux`;
export const KEY_IDENTIFICATION_ANIMAL = `${KEY_IDENTIFICATION}/animaux`;
export const TITLE_IDENTIFICATION_ANIMAL = "Liste des Animaux Identifiés";
